<div class="time-frame-container">
  <span>Every:</span>
  @if (TimeFrames) {
  <mat-form-field id="timeFrame">
    <mat-select [formControl]="selectTimeFrameFormControl" [disabled]="disableTimeFrame"
      (selectionChange)="timeFrameInputChanged($event)">
      @for (item of TimeFrames; track item) {
      <mat-option [value]="item">
        {{item.name}}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
  @if (showTimePeriod) {
  <span class="pad-l">For:</span>
  }
  @if (TimePeriods && showTimePeriod) {
  <mat-form-field id="timePeriod">
    <mat-select [formControl]="selectTimePeriodFormControl" (selectionChange)=timePeriodInputChanged($event)>
      @for (timeItem of TimePeriods; track timeItem) {
      <mat-option [value]="timeItem">
        {{timeItem.name}}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
</div>